import {NgModule} from "@angular/core";
import {HomeComponent} from "./home.component";
import {ArchiveComponent} from "./highlights/archive/archive.component";
import {CommonModule} from "@angular/common";
import {RouterModule} from "@angular/router";
import {HighlightsModule} from "./highlights/highlights/highlights.module";

@NgModule({
  imports: [CommonModule, RouterModule, HighlightsModule],
  declarations: [HomeComponent, ArchiveComponent]
})
export class HomeModule {}
